import { ViewModel,View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { DebitPaymentViewModel } from "./debitPayment-viewModel";


export class DebitCardSelectorViewModel extends SelectorBaseViewModel<debitCard>{
    constructor(parentViewModel: DebitPaymentViewModel) {
        super(parentViewModel);
        this._parent = parentViewModel;
    }

    public getTypeId(): string {
        return "VM-88942B5E-C379-4C92-8F53-B0654A1CA75C"
    }

    private _parent: DebitPaymentViewModel;

    protected async loadData(): Promise<debitCard[]> {
        let result =await ServerConnection.callServer('/Complex/SellServices/GetAccessibleDebitGatewaysForCustomerPayment',{
            IsFromRootDistrict: this._parent.isFromRootDistrict
        })
        return result.Cards.map(x=>{
            let r = new debitCard(this);
            r.id = x.Id;
            r.title = `${x.AccountName} - ${x.CardNumber}`;
            return r;
        });
    }

}

export class debitCard extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}